import { render, staticRenderFns } from "./RollCallCertificationStatistics.vue?vue&type=template&id=9ce96840"
import script from "./RollCallCertificationStatistics.vue?vue&type=script&lang=js"
export * from "./RollCallCertificationStatistics.vue?vue&type=script&lang=js"
import style0 from "./RollCallCertificationStatistics.vue?vue&type=style&index=0&id=9ce96840&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports